import React from 'react'
import Header from '../Components/Header'
import Slider from '../Components/Slider'
import Home from '../Components/Home'
import Footer from '../Components/Footer'

function Mainpage() {
  return (
    <div>
      <Header/>
      <Slider/>
      <Home/>
      <Footer/>
    </div>
  )
}

export default Mainpage